import { object } from 'zod';

import { CountProductsBySchema } from '../count-products-by/count-products-by.validation';
import { ProductCountingRoundStrategySchema } from '../product-counting-round-strategy/product-counting-round-strategy.validation';
import { ProductGroupsSchema } from '../product-groups/product-groups.validation';

export const BaseEligibleEarnSchema = object({
  countProductsBy: CountProductsBySchema,
  roundCountedProducts: ProductCountingRoundStrategySchema,
  eligibleProductGroups: ProductGroupsSchema,
});
